import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { ACTION } from '@kioskgaming/ui';
import { requestForgotPasswordOtp } from '../services/cashierApi';

export default function ForgotPasswordContactPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const onGetOtp = async () => {
    if (!email.trim()) {
      toast.error('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      const res = await requestForgotPasswordOtp(email.trim());
      if (!res.success || !res.data?.token) {
        toast.error(res.message || 'Failed to send OTP');
        return;
      }
      toast.success('OTP sent successfully');
      navigate('/forgot-password/otp', {
        state: {
          requestToken: res.data.token,
          contact: email.trim(),
          nextResendAt: res.data.next_resend_at,
        },
      });
    } catch (error: unknown) {
      const msg =
        (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
        'Failed to send OTP';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-gradient-to-br from-amber-50 via-white to-emerald-50 px-3 py-6 sm:flex sm:items-center sm:justify-center sm:px-4 sm:py-10">
      <div className="mx-auto w-full max-w-md rounded-2xl border border-amber-100 bg-white p-5 shadow-xl shadow-amber-100/50 sm:p-8">
        <p className="text-center text-xs font-medium uppercase tracking-wide text-amber-700">Step 1 of 3</p>
        <h1 className="mt-1 text-center text-xl font-bold text-gray-900">Forgot password</h1>
        <p className="mt-2 text-center text-sm text-gray-600">
          Enter the email address registered to your Cashier account.
        </p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20"
              placeholder="cashier@example.com"
            />
          </div>
          <button
            type="button"
            onClick={onGetOtp}
            disabled={loading}
            className="w-full rounded-lg bg-amber-600 py-2.5 text-sm font-semibold text-white hover:bg-amber-700 disabled:opacity-60"
          >
            {loading ? 'Sending…' : 'Get OTP'}
          </button>
        </div>

        <Link to="/login" className="mt-6 block text-center text-sm text-amber-800 hover:underline">
          {ACTION.backToSignIn}
        </Link>
      </div>
    </div>
  );
}
